import React from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak from "./Keycloak";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import WelcomePage from "./pages/Homepage";
import AvatarPage from "./pages/Avatar";
import TenantPage from "./pages/Tenant";
import ConfigPage from "./pages/Configmake";
import PrivateRoute from "./helpers/PrivateRoute";
import { SpeechToText } from './components/SpeechToText';
function App() {
  return (
    <div className='content' >

      <ReactKeycloakProvider initOptions={{ onLoad: 'login-required' }} authClient={keycloak}>
      <SpeechToText>
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<WelcomePage />} />
            <Route
              path="/avatar"
              element={
                <PrivateRoute>
                  <AvatarPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/config"
              element={
                <PrivateRoute>
                  <ConfigPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/tenant"
              element={
                <PrivateRoute>
                  <TenantPage />
                </PrivateRoute>
              }
            />


          </Routes>
        </BrowserRouter>
      </SpeechToText> 
      </ReactKeycloakProvider>
    </div>
  );
}

export default App;